import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Transition } from 'react-transition-group';
import { StyledBlade } from './Blade.styled';
import { BladeOverlay } from './BladeOverlay';
export var Blade = /*#__PURE__*/function (_React$Component) {
  function Blade() {
    var _this;
    _classCallCheck(this, Blade);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Blade, [].concat(args));
    _defineProperty(_this, "isClosing", false);
    _defineProperty(_this, "bladeRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "focusRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "handleKeyDown", function (e) {
      var _e$key;
      var _this$props$closeOnEs = _this.props.closeOnEscape,
        closeOnEscape = _this$props$closeOnEs === void 0 ? true : _this$props$closeOnEs;
      if (closeOnEscape && ((_e$key = e.key) === null || _e$key === void 0 ? void 0 : _e$key.toLowerCase()) === 'escape') {
        _this.close();
      }
    });
    _defineProperty(_this, "close", function () {
      if (_this.isClosing) {
        return;
      }
      _this.isClosing = true;
      _this.tryDismiss();
    });
    _defineProperty(_this, "tryDismiss", function () {
      if (!_this.props.onDismiss) {
        throw new Error('[citrix-ui] the Blade component expects the onDismiss prop to be supplied from the component passed to showBlade. ' + 'Did you forget to spread props into Blade?');
      }
      _this.props.onDismiss();
    });
    _defineProperty(_this, "stop", function (e) {
      e.stopPropagation();
    });
    _defineProperty(_this, "focusFirst", function () {
      var elements = _this.getFocusableElements();
      if (elements) {
        var firstElement = elements[0];
        firstElement.focus();
      }
    });
    _defineProperty(_this, "focusLast", function () {
      var elements = _this.getFocusableElements();
      if (elements) {
        var lastElement = elements[elements.length - 1];
        lastElement.focus();
      }
    });
    return _this;
  }
  _inherits(Blade, _React$Component);
  return _createClass(Blade, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className,
        dataTestIdSuffix = _this$props['data-testid-suffix'];
      return /*#__PURE__*/React.createElement(Transition, {
        appear: true,
        "in": this.props.isOpen,
        timeout: 0
      }, function (animationState) {
        return /*#__PURE__*/React.createElement(BladeOverlay, {
          onDismiss: _this2.close,
          overlayClassName: _this2.props.overlayClassName,
          transitionState: animationState
        }, /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          onFocus: _this2.focusLast
        }), /*#__PURE__*/React.createElement(StyledBlade, {
          "data-testid": dataTestIdSuffix ? "citrix-ui-blade-".concat(dataTestIdSuffix) : 'citrix-ui-blade',
          className: className,
          animationState: animationState,
          ref: _this2.bladeRef,
          onBlur: _this2.stop,
          onChange: _this2.stop,
          onClick: _this2.stop,
          onContextMenu: _this2.stop,
          onDoubleClick: _this2.stop,
          onDrag: _this2.stop,
          onDragEnd: _this2.stop,
          onDragEnter: _this2.stop,
          onDragExit: _this2.stop,
          onDragLeave: _this2.stop,
          onDragOver: _this2.stop,
          onDragStart: _this2.stop,
          onDrop: _this2.stop,
          onInput: _this2.stop,
          onInvalid: _this2.stop,
          onKeyDown: _this2.stop,
          onKeyPress: _this2.stop,
          onKeyUp: _this2.stop,
          onMouseDown: _this2.stop,
          onMouseEnter: _this2.stop,
          onMouseLeave: _this2.stop,
          onMouseMove: _this2.stop,
          onMouseOut: _this2.stop,
          onMouseOver: _this2.stop,
          onMouseUp: _this2.stop
        }, /*#__PURE__*/React.createElement("div", {
          tabIndex: -1,
          ref: _this2.focusRef
        }), /*#__PURE__*/React.createElement(React.Fragment, null, _this2.props.children)), /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          onFocus: _this2.focusFirst
        }));
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeyDown, true);
      var _this$props$autoFocus = this.props.autoFocus,
        autoFocus = _this$props$autoFocus === void 0 ? true : _this$props$autoFocus;
      if (autoFocus) {
        var _this$focusRef$curren;
        (_this$focusRef$curren = this.focusRef.current) === null || _this$focusRef$curren === void 0 ? void 0 : _this$focusRef$curren.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyDown, true);
    }
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements() {
      var _this$bladeRef$curren;
      return (_this$bladeRef$curren = this.bladeRef.current) === null || _this$bladeRef$curren === void 0 ? void 0 : _this$bladeRef$curren.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }
  }]);
}(React.Component);